import http from "./http.service";
import authService from "./authService";

/**
 * Impersonacion desde el back office: el admin entra como un usuario para ayudarlo o configurarle la
 * cuenta. El cambio de sesion lo hace authService (iniciarImpersonacion / salirImpersonacion).
 */
class ImpersonacionService {

    /** Los miembros de una cuenta, el dueño primero. */
    miembros = (cuentaId: number): Promise<any[]> =>
        http.get(`/api/admin/impersonacion/cuentas/${cuentaId}/miembros`).then((r: any) => r.miembros || []);

    /**
     * Entra como el usuario. `info` es lo que muestra el cartel de arriba ({nombre, email, cuentaNombre}).
     * Cae en el panel si vende y en el inicio si es comprador.
     */
    entrar = (userId: number, info: any): Promise<void> =>
        http.post(`/api/admin/impersonacion/usuarios/${userId}`).then((r: any) => {
            const destino = r.user?.token?.cuentaId ? "/vendedor/dashboard" : "/";
            authService.iniciarImpersonacion(r.user, info, destino);
        });
}

const impersonacionService = new ImpersonacionService();

export default impersonacionService;
